
import { CreateElement } from "vue";
import { Component, Prop, Vue } from "vue-property-decorator";
// Components
import CProdProvider from "@/components/app/global/contractProducts/cProdProvider.vue";
import CProdProvProvider from "@/components/app/global/contractProducts/cProdProvProvider.vue";

@Component
export default class CProdProvidersWrapper extends Vue {
  @Prop({ default: false })
  public readonly handleLoading!: boolean;

  public render(h: CreateElement) {
    const contractId = this.$route.params?.contractId;
    const productId = this.$route.params?.productId;
    const props = { ...this.$props, contractId, productId };
    return h(CProdProvider, { props, key: productId }, [
      h(CProdProvProvider, { props }, [
        h("div", this.$scopedSlots?.default && this.$scopedSlots.default({}))
      ])
    ]);
  }
}
